import { Save, Trash2 } from "lucide-react";
import { useState } from "react";

const GalleryAdminItem = ({ item, onSave, onDelete }) => {
  const [draft, setDraft] = useState(item);
  const setField = (field, value) => setDraft((current) => ({ ...current, [field]: value }));

  return (
    <article className="admin-gallery-item" data-testid={`admin-gallery-item-${item.id}`}>
      <img src={item.image_url} alt={item.alt} />
      <div className="admin-gallery-copy">
        <p className="gallery-category">{item.category} · {item.location}</p>
        <h3>{item.title}</h3>
        <div className="admin-gallery-details">
          <label>Room type<input data-testid={`admin-room-type-${item.id}`} value={draft.room_type || ""} onChange={(event) => setField("room_type", event.target.value)} /></label>
          <label>Finish<input data-testid={`admin-finish-${item.id}`} value={draft.finish || ""} onChange={(event) => setField("finish", event.target.value)} /></label>
        </div>
        <button className="admin-details-save" type="button" onClick={() => onSave(draft)} data-testid={`admin-save-details-${item.id}`}><Save size={14} /> Save details</button>
      </div>
      <button className="admin-delete-button" type="button" onClick={() => onDelete(item.id)} aria-label={`Remove ${item.title}`} data-testid={`admin-delete-image-${item.id}`}><Trash2 size={17} /></button>
    </article>
  );
};

export default GalleryAdminItem;
